import { render, staticRenderFns } from "./OfflineWarning.vue?vue&type=template&id=bddd88ac&"
import script from "./OfflineWarning.vue?vue&type=script&lang=js&"
export * from "./OfflineWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports